module.exports = __webpack_public_path__ + "6069ef35af1e6b617f947c7459a96a9a.svg";